import React, { useState } from 'react';

type Props = {
  onClose: () => void;
  onSave: (phone: string) => void;
};

export default function WhatsAppModal({ onClose, onSave }: Props) {
  const [phone, setPhone] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = phone.trim();
    if (!trimmed) return;
    onSave(trimmed);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md rounded-2xl bg-[#0f0a1f] p-6 shadow-xl border border-white/10">
        <h3 className="text-xl font-semibold text-white mb-2">¿Compartes tu WhatsApp?</h3>
        <p className="text-sm text-white/70 mb-4">
          Lo usaremos solo para enviarte novedades y tips de PromptStudio. Es opcional.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="tel"
            placeholder="+57 300 123 4567"
            className="w-full rounded-xl bg-white/10 text-white placeholder-white/50 px-4 py-3 outline-none focus:ring-2 focus:ring-purple-500"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-white/10 text-white hover:bg-white/20"
            >
              Ahora no
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-xl bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
